import React from 'react';


function Disclaimer() {
    
    return (
        <div className="alert alert-info">
            <p>Mitsamtykke er udelukkende en service, du kan benytte til at få vist og tilbagekaldt de samtykker, du har afgivet.
                Mitsamtykke har kun registreret samtykker, der er afgivet til de virksomheder, der er tilknyttet Mitsamtykke.dk.</p>
            <p>Mitsamtykke er ikke ansvarlige for oprindelsen af samtykkerne, de data, der er oplyst som afgivet ifm. samtykkerne eller
                gyldigheden af selve samtykkerne. Har du spørgsmål eller tvivl omkring de samtykker, du kan se på Mitsamtykke.dk, eller de data,
                der er registreret, beder vi dig derfor kontakte den eller de annoncører, som samtykkerne er afgivet til.</p>
        </div>
    );
}

export default Disclaimer;
